<template>
  <details class="user-menu" :class="{ 'user-menu--dark': dark }">
    <summary class="user-menu__trigger">
      <div
        class="avatar avatar--sm"
        :style="
          getCurrentUser.photo
            ? `background-image:url(${getCurrentUser.photo});background-size:cover;background-position:center;`
            : ''
        "
      >
        <span v-if="!getCurrentUser.photo">{{ initials }}</span>
      </div>
      <span class="nm">{{ firstName }}</span>
      <svg
        class="user-menu__chevron"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </summary>

    <div class="user-menu__dropdown">
      <router-link
        v-for="item in menuItems"
        :key="item.link"
        :to="item.link"
        class="user-menu__item"
      >
        {{ item.label }}
      </router-link>
      <div class="user-menu__divider" />
      <button
        type="button"
        class="user-menu__item user-menu__item--danger"
        @click="handleLogout"
      >
        Desconectar
      </button>
    </div>
  </details>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { isReceptionist } from "../utils/userRole";

export default {
  name: "AppBarUserMenu",

  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      this.logout();
    }
  },

  computed: {
    ...mapGetters("user", ["getCurrentUser"]),

    initials() {
      const name =
        this.getCurrentUser && this.getCurrentUser.name
          ? this.getCurrentUser.name
          : "";
      return name
        .split(" ")
        .slice(0, 2)
        .map(function(n) {
          return n[0];
        })
        .join("")
        .toUpperCase();
    },
    firstName() {
      const name =
        this.getCurrentUser && this.getCurrentUser.name
          ? this.getCurrentUser.name
          : "";
      return name
        .split(" ")
        .slice(0, 2)
        .join(" ");
    },
    menuItems() {
      if (isReceptionist(this.getCurrentUser)) {
        return [
          { link: "/profile", label: "Perfil" },
          { link: "/nurseschedule", label: "Marcar consulta" },
          { link: "/dashboard", label: "Minhas consultas" }
        ];
      }
      return [
        { link: "/", label: "Meu espaço" },
        { link: "/profile", label: "Minha conta" },
        { link: "/consultas", label: "Minhas consultas" }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
/* ─── Elemento nativo details ─── */
.user-menu {
  position: relative;
  list-style: none;
}

/* Remove marcador nativo do summary */
.user-menu__trigger {
  list-style: none;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  cursor: pointer;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-md);
  transition: background 0.12s;
  user-select: none;

  &::-webkit-details-marker {
    display: none;
  }
  &::marker {
    display: none;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .nm {
    font-size: var(--font-size-sm);
    font-weight: var(--fw-bold);
    color: var(--color-gray-800);
  }
}

.user-menu__chevron {
  color: var(--color-gray-400);
  transition: transform 0.18s;
}

.user-menu[open] .user-menu__chevron {
  transform: rotate(180deg);
}

/* ─── Dropdown ─── */
.user-menu__dropdown {
  position: absolute;
  top: calc(100% + var(--space-2));
  right: 0;
  min-width: 200px;
  background: #fff;
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  z-index: 1001;
  overflow: hidden;
  padding: var(--space-1) 0;
}

.user-menu__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: var(--space-3) var(--space-4);
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-gray-700);
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.1s, color 0.1s;

  &:hover {
    background: var(--color-gray-50);
    color: var(--color-gray-900);
  }
  &.router-link-exact-active {
    color: var(--color-primary);
  }

  &--danger {
    color: var(--color-danger);
    &:hover {
      background: #fef2f2;
      color: var(--color-danger);
    }
  }
}

.user-menu__divider {
  height: 1px;
  background: var(--color-gray-100);
  margin: var(--space-1) 0;
}

/* ─── Variante escura (NavBar primário) ─── */
.user-menu--dark {
  .user-menu__trigger {
    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
    .nm {
      color: rgba(255, 255, 255, 0.9);
    }
  }

  .user-menu__chevron {
    color: rgba(255, 255, 255, 0.7);
  }
}

@media (max-width: 640px) {
  .user-menu__trigger .nm,
  .user-menu__chevron {
    display: none;
  }
}
</style>
